import { BottomNavigation, BottomNavigationAction, Box } from '@mui/material';
import useMobileDeviceDetection, { useTabletDetection, useMobileDetect } from "containers/chat/hooks";
import WidgetsMenu from "components/widgetsMenu";
import Chat from "containers/chat/popup";
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from "react-redux";
import IdeaModal from 'features/ideaModal';
import { useLocation, useNavigate } from "react-router-dom";
import { useCurrentClass } from "store/classes/selectors";
import { useCurrentUser } from 'store/users/selectors';
import { revokeAllWidget } from "store/wheel/actions";
import { useNoiseMeter } from "store/wheel/selectors";
import styled from 'styled-components';
import OneGameJoinModal from 'components/OneGame/OneGameJoinModalButton';
import { bellBtnmenu, booksBtnMenu, gradeBtnmenu, homeBtnMenu, messageBtnmenu, roboBtnmenu } from "utils/assets/images/icons";
import { WidgetsOutlined } from '@mui/icons-material';
import { get } from "lodash";
import BingoModal from "modules/bingoModule";
import { useFullScreen } from "utils/context/FullScreenProvider";
import DebateModal from 'modules/DebateComponent';
import { redirectToHome } from 'utils/config/navigation';

const Wrapper = styled.div`
   position: fixed;
   right: 0px;
   bottom: 0px;
   display: flex;
   flex-direction: row;
   z-index: ${(props) => props?.pathChecker && props?.isStudent ? "999" : "9999 !important"};
   align-items: flex-end;
//    justify-content:flex-end;
   gap: 4px;
`;

export default function BottomIcons({ sharableWidget, trafficWidgetData }) {
    const location = useLocation();
  	const navigate = useNavigate();
    const isMobile = useMobileDetect();
    const deviceType = useMobileDeviceDetection();
    const tabletType = useTabletDetection();
    const [widgetOpened, setIsWidgetOpened] = useState(false);
    const dispatch = useDispatch();
    const currentUser = useCurrentUser()
    const currentClass = useCurrentClass();
    const [noiseModal, invokeNoiseModal, revokeNoiseModal] = useNoiseMeter()
    const isTeacherHome = location.pathname === "/teacher/home" || location.pathname === "/student/home";
    const isChatWindow = window.location.pathname.includes("/chat");
    const isStudent = currentUser?.role === "student";
    const isTeacher = currentUser?.role === "teacher";
    const [value, setValue] = React.useState(0);
    const [currentValue, setCurrentValue] = React.useState(0);
    const [ideasModal, setIdeasModal] = useState(false);
    const teacherOrStudent = isStudent || isTeacher;
    const [previewClass, setPreviewClass] = useState(currentClass?.id)
    const isCanvasUser = !!get(currentUser, "canvas_id")
    const { currentFullScreen, FullScreenMode, ExitFullScreenMode } = useFullScreen();

    useEffect(() => {
        if (location.pathname.includes("/chat")) {
            setCurrentValue(3);
        } else if (location.pathname.includes("/notification")) {
            setCurrentValue(2);
        } else if ((location.pathname + location.search)?.includes("/admin/class?view=gradebook")) {
            setCurrentValue(4);
        } else if (((location.pathname + location.search)?.includes("/admin/class?view=home")) || ((location.pathname + location.search)?.includes("/student/class?view=home"))) {
            setCurrentValue(1);
        } else if(((location.pathname + location.search)?.includes("/student/class?view=assessments"))){
            setCurrentValue(5);
        } else if (location.pathname.includes("/assignmentList")) {
            setCurrentValue(7);
        } else if (location.pathname.includes("/ideas")) {
            setCurrentValue(6);
        }
    }, [location.pathname, location.search])

    const handleClick = useCallback((newValue) => {
        setValue(newValue);
        setCurrentValue(newValue);
    }, []);

    const handleNavigation = useCallback((path) => {
        navigate(path);
    }, [navigate]);


    useEffect(() => {
        resetWidget()
    }, [currentClass])

    const resetWidget = async () => {
        if (currentClass?.id !== previewClass) {
            await dispatch(revokeAllWidget());
            revokeNoiseModal();
            setPreviewClass(currentClass?.id)
        }
    }

    if (!currentUser || isTeacherHome || (isChatWindow&&!deviceType)) return null;



    const pathChecker = location?.pathname?.includes("/chat");
    const handleClickChat = () => {
        if (pathChecker) {
            navigate(redirectToHome(currentUser) || '-1')
        } else {
            navigate('/chat');
        }
    };
    return (

        <>
            <Wrapper id="bottomContnrRemove" className="websiteBtmFtr" pathChecker={pathChecker || false} isStudent={isStudent || false} style={{ width: deviceType ? '100%' : 'initial', zIndex: pathChecker ? 999 : 9, }}>
                {deviceType ? <div className={`bottom-container ${isCanvasUser && 'canVasBotomFooter'}`} style={{ width: '100%', border: '0.6px solid #e7eaef', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)' }}>
                    {!currentFullScreen && teacherOrStudent && (
                        <Box className="bottom-container-box">
                            <BottomNavigation
                                showLabels
                                value={value}
                                onChange={(event, newValue) => setValue(newValue)}
                            >
                                <BottomNavigationAction icon={<img src={homeBtnMenu} style={{ height: 20, boxShadow: currentValue === 1 ? '' : 'none', scale: currentValue === 1 ? 1.5 : 1 }} />} onClick={() => {
                                    navigate(currentUser?.role === "teacher" ? "/admin/class?view=home" : "/student/class?view=home")
                                    setCurrentValue(1);
                                }} />
                                <BottomNavigationAction icon={<img src={bellBtnmenu} style={{ height: 20, boxShadow: currentValue === 2 ? '' : 'none', scale: currentValue === 2 ? 1.5 : 1 }} />} onClick={() => {
                                    navigate('/notification')
                                    setCurrentValue(2)
                                }} />
                                <BottomNavigationAction icon={<img src={messageBtnmenu} style={{ height: 20, boxShadow: currentValue === 3 ? '' : 'none', scale: currentValue === 3 ? 1.5 : 1 }} />} onClick={() => {
                                    // navigate('/chat')
                                    handleClickChat()
                                    handleClick(3)
                                }} />
                                {tabletType && currentUser?.role === "teacher" && (
                                    <BottomNavigationAction icon={<WidgetsOutlined style={{ height: 20, boxShadow: currentValue === 8 ? '' : 'none', scale: currentValue === 8 ? 1.5 : 1 }} />} onClick={() => {
                                        // navigate(currentUser?.role === "teacher" ? "/admin/class?view=home" : "/student/class?view=home")
                                        setIsWidgetOpened(prev => !prev);
                                        setCurrentValue(8);
                                    }} />
                                )}
                                {currentUser?.role === "teacher" ? <BottomNavigationAction icon={<img src={gradeBtnmenu} style={{ height: 20, boxShadow: currentValue === 4 ? '' : 'none', scale: currentValue === 4 ? 1.5 : 1 }} />} onClick={() => {
                                    navigate('/admin/class?view=gradebook')
                                    setCurrentValue(4)
                                }} />
                                    : <BottomNavigationAction icon={<img src={gradeBtnmenu} style={{ height: 20, boxShadow: currentValue === 5 ? '' : 'none', scale: currentValue === 5 ? 1.5 : 1 }} />} onClick={() => {
                                        navigate('/student/class?view=assessments')
                                        setCurrentValue(5)
                                    }} />}
                                {currentUser?.role === "teacher" ? <BottomNavigationAction icon={<img src={roboBtnmenu} style={{ height: 20, boxShadow: currentValue === 6 ? '' : 'none', scale: currentValue === 6 ? 1.5 : 1 }} />} onClick={() => {
                                    setIdeasModal(true)
                                    setCurrentValue(6)
                                }} />
                                    : <BottomNavigationAction icon={<img src={booksBtnMenu} style={{ height: 20, boxShadow: currentValue === 7 ? '' : 'none', scale: currentValue === 7 ? 1.5 : 1 }} />} onClick={() => {
                                        navigate('/assignmentList')
                                        setCurrentValue(7)
                                    }} />
                                }

                                
                            </BottomNavigation>
                            {isStudent && <BingoModal type="bottom" showIcon={false} /> }
                        </Box>
                    )}

                </div> : <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, zIndex: '99999' }}>
                    {/* {isTeacher && <WheelModal />}
                    {isTeacher && <IdeaModal />} */}
                    {isStudent && <div><BingoModal type="bottom" /></div> }
                    {isStudent && !isTeacher && <OneGameJoinModal />}
                    {isStudent && <DebateModal />}
                    {!isChatWindow && isStudent && <Chat />}
                </div>}

                <div style={{ display: 'none' }}><IdeaModal ideasModal={ideasModal} setIdeasModal={setIdeasModal} /></div>
            </Wrapper>
            {!currentFullScreen && (
            <Wrapper style={{ zIndex: 111 }}>
                {isTeacher && (
                    <div className="widget-menu-bar" style={{ display: 'flex', width: "100%", alignItems: 'center', justifyContent: "end", gap: 4, zIndex: '999', position: "absolute", maxWidth: "28%", right: 0, left: "auto" }}>
                        <WidgetsMenu trafficWidgetData={trafficWidgetData} sharableWidget={sharableWidget} tabletMode={tabletType} widgetOpened={widgetOpened} setIsWidgetOpened={() => setIsWidgetOpened(false)} checkingCanvasUser={isCanvasUser} />
                    </div>
                )}
            </Wrapper>
            )}

        </>
    );
}
